import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { addUpsellItem } from "data/cart";
import gaEvent from "helpers/ga-event";
import GlobalContext from "services/global-context";
import * as styles from "./style.mod.scss";
import { trackProduct } from "helpers/analytics";
import translations from "locales";
import { PlusLg } from "react-bootstrap-icons";
import Money from "components/money";

const CartRecommendations = ({ showRecommendations, products }) => {
  if (!showRecommendations) return<></>;

  const { refreshCart, setLoadingVisible } = useContext(GlobalContext);
  const cartLoc = translations.cart;

  const addUpsellToCart = async (variant) => {
    gaEvent("Cart", "Click", "Added upsell", variant.priceV2.amount);
    setLoadingVisible(true);
    await addUpsellItem(variant.id);
    refreshCart();
    trackProduct({ variant });
    window._mfq.push(["tag", "tookUpsell"]);
  };


  return (
    <div>
      <div id="recommended-products" className={styles.recommendations}>
        <h4 className={styles.title}>{cartLoc.recommendation}</h4>
        {products?.map((item) => (
          <div key={item?.id} className={styles.recommendation}>
            <div className={styles.imageWrapper}>
              {item.percOff ? <span className={styles.badge}>-{item.percOff}%</span> : ""}
              <img className={styles.image} src={item?.image?.src} alt={item?.image?.src?.alt} />
              <span className={styles.addToCart} onClick={() => addUpsellToCart(item)}><PlusLg /></span>
            </div>
            <div className={styles.bodyWrapper}>
              <span className={styles.name}>{item.title}</span>
              <hr />
              <span className={styles.description}>{item.upsellSubtitle}</span>
              <div className={styles.priceWrapper}>
                <span className={styles.comparePrice}>
                  <Money value={item.compareAtPriceV2?.amount} currency={item.compareAtPriceV2?.currencyCode} />
                </span>
                <span className={styles.price}>
                  <Money value={item.priceV2.amount} currency={item.priceV2?.currencyCode} />
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div id="recommendations-mobile" className={`${styles.recommendations} ${styles.inMobile}`}>
        <h4 className={styles.title}>{cartLoc.recommendation}</h4>
        <Swiper
          slidesPerGroup={1}
          slidesPerView={2.2}
          spaceBetween={13}
          modules={[Pagination]}
          pagination={{ clickable: true }}
        >
          {products?.map((item) => (
            <SwiperSlide key={item.id}>
              <div key={item.id} className={styles.recommendation}>
                <div className={styles.imageWrapper}>
                  {item.percOff ? <span className={styles.badge}>-{item.percOff}%</span> : ""}
                  <img className={styles.image} src={item?.image?.src} alt={item?.image?.src?.alt} />
                  <span className={styles.addToCart} onClick={() => addUpsellToCart(item)}><PlusLg /></span>
                </div>
                <div className={styles.bodyWrapper}>

                  <span className={styles.name}>{item.title}</span>
                  <span className={styles.description}>{item.upsellSubtitle}</span>

                  <div className={styles.priceWrapper}>
                    <span className={styles.comparePrice}>
                      <Money value={item.compareAtPriceV2?.amount} currency={item.compareAtPriceV2?.currencyCode} />
                    </span>
                    <span className={styles.price}>
                      <Money value={item.priceV2.amount} currency={item.priceV2?.currencyCode} />
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default CartRecommendations;